import { render, staticRenderFns } from "./Commerces.vue?vue&type=template&id=ada32976&"
import script from "./Commerces.vue?vue&type=script&lang=js&"
export * from "./Commerces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports